import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';

import { RealtorFacade } from 'src/app/modules/ngrx-store/realtor/realtor.facade';

import { CORE_ROUTES, NAVIGATION_ROUTES, PREVIEW_REALTOR_SELECTED_INFO } from 'src/app/modules/shared/constants/route-paths';

/**
 * Guards the preview realtor portal (preview/realtor/:salesAgreementId).
 *
 * The portal is only reachable by selecting a home in Client Management, which lists the previewed realtor's current grants.
 * Any other entry, such as a sales agreement id typed or changed in the url, clears the previewed realtor and is sent to
 * Client Management, which asks for the realtor's email again.
 */
export const previewRealtorGuard: CanActivateFn = () => {
	const router = inject(Router);
	const realtorFacade = inject(RealtorFacade);
	const selectedFromClientManagement = router.currentNavigation()?.extras.info === PREVIEW_REALTOR_SELECTED_INFO;

	if (selectedFromClientManagement) {
		return true;
	}

	realtorFacade.clearPreviewRealtor();

	return router.parseUrl(`/${CORE_ROUTES.Preview}/${NAVIGATION_ROUTES.Realtor}`);
};
